module.exports = __webpack_public_path__ + "static/ForestNicer-3e38534231b27807687406afd3db0e3d.png";